"use strict";

var _a;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currencies = exports.Currency = void 0;
var enums_1 = require("./enums/");
/**
 * Валюта
 *
 * @see http://www.localeplanet.com/icu/currency.html
 */
var Currency = /** @class */function () {
  function Currency(values) {
    if (values === void 0) {
      values = {};
    }
    this.formatString = '{value}{symbol}';
    this.fraction = 2;
    var properties = ['id', 'symbol', 'formatString', 'fraction', 'title'];
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
  }
  Currency.prototype.formatFixed = function (value, fraction) {
    fraction = fraction || this.fraction;
    return this.formatString.replace('{sign}', value < 0 ? '-' : '').replace('{value}', Math.abs(value).toFixed(fraction)).replace('{symbol}', this.symbol);
  };
  Currency.prototype.format = function (value) {
    return this.formatString.replace('{sign}', value < 0 ? '-' : '').replace('{value}', value.toString()).replace('{symbol}', this.symbol);
  };
  Currency.defaultCurrency = enums_1.CurrencyEnum.usd;
  return Currency;
}();
exports.Currency = Currency;
exports.currencies = (_a = {}, _a[enums_1.CurrencyEnum.unknown] = new Currency({
  id: enums_1.CurrencyEnum.unknown,
  symbol: '',
  formatString: '{sign}{value}',
  title: 'currency.UNKNOWN'
}), _a[enums_1.CurrencyEnum.usd] = new Currency({
  id: enums_1.CurrencyEnum.usd,
  symbol: '$',
  formatString: '{sign}{symbol}{value}',
  title: 'currency.USD'
}), _a[enums_1.CurrencyEnum.credits] = new Currency({
  id: enums_1.CurrencyEnum.credits,
  symbol: 'Δ',
  fraction: 0,
  formatString: '{sign}{value}{symbol}',
  title: 'currency.CREDITS'
}), _a[enums_1.CurrencyEnum.rub] = new Currency({
  id: enums_1.CurrencyEnum.rub,
  symbol: '₽',
  fraction: 0,
  formatString: '{sign}{value}{symbol}',
  title: 'currency.RUB'
}), _a[enums_1.CurrencyEnum.eur] = new Currency({
  id: enums_1.CurrencyEnum.eur,
  symbol: '€',
  formatString: '{sign}{symbol}{value}',
  title: 'currency.EUR'
}), _a[enums_1.CurrencyEnum.gbp] = new Currency({
  id: enums_1.CurrencyEnum.gbp,
  symbol: '₤',
  formatString: '{sign}{symbol}{value}',
  title: 'currency.GBP'
}), _a[enums_1.CurrencyEnum.uah] = new Currency({
  id: enums_1.CurrencyEnum.uah,
  symbol: '₴',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.UAH'
}), _a[enums_1.CurrencyEnum.byr] = new Currency({
  id: enums_1.CurrencyEnum.byr,
  symbol: 'BYR',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.BYR'
}), _a[enums_1.CurrencyEnum.byn] = new Currency({
  id: enums_1.CurrencyEnum.byn,
  symbol: 'BYN',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.BYN'
}), _a[enums_1.CurrencyEnum.kzt] = new Currency({
  id: enums_1.CurrencyEnum.kzt,
  symbol: '₸',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.KZT'
}), _a[enums_1.CurrencyEnum.azn] = new Currency({
  id: enums_1.CurrencyEnum.azn,
  symbol: '₼',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.AZN'
}), _a[enums_1.CurrencyEnum.chf] = new Currency({
  id: enums_1.CurrencyEnum.chf,
  symbol: 'CHF',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.CHF'
}), _a[enums_1.CurrencyEnum.czk] = new Currency({
  id: enums_1.CurrencyEnum.czk,
  symbol: 'CZK',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.CZK'
}), _a[enums_1.CurrencyEnum.cad] = new Currency({
  id: enums_1.CurrencyEnum.cad,
  symbol: '$',
  formatString: '{symbol}{sign}{value}',
  title: 'currency.CAD'
}), _a[enums_1.CurrencyEnum.pln] = new Currency({
  id: enums_1.CurrencyEnum.pln,
  symbol: 'PLN',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.PLN'
}), _a[enums_1.CurrencyEnum.sek] = new Currency({
  id: enums_1.CurrencyEnum.sek,
  symbol: 'SEK',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.SEK'
}), _a[enums_1.CurrencyEnum.try] = new Currency({
  id: enums_1.CurrencyEnum.try,
  symbol: '₺',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.TRY'
}), _a[enums_1.CurrencyEnum.cny] = new Currency({
  id: enums_1.CurrencyEnum.cny,
  symbol: '¥',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.CNY'
}), _a[enums_1.CurrencyEnum.inr] = new Currency({
  id: enums_1.CurrencyEnum.inr,
  symbol: '₹',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.INR'
}), _a[enums_1.CurrencyEnum.brc] = new Currency({
  id: enums_1.CurrencyEnum.brc,
  symbol: '$',
  formatString: '{symbol}{sign}{value}',
  title: 'currency.BRC'
}), _a[enums_1.CurrencyEnum.zar] = new Currency({
  id: enums_1.CurrencyEnum.zar,
  symbol: 'ZAR',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.ZAR'
}), _a[enums_1.CurrencyEnum.uzs] = new Currency({
  id: enums_1.CurrencyEnum.uzs,
  symbol: 'UZS',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.UZS'
}), _a[enums_1.CurrencyEnum.bgl] = new Currency({
  id: enums_1.CurrencyEnum.bgl,
  symbol: 'BGL',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.BGL'
}), _a[enums_1.CurrencyEnum.jpy] = new Currency({
  id: enums_1.CurrencyEnum.jpy,
  symbol: '¥',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.JPY'
}), _a[enums_1.CurrencyEnum.nok] = new Currency({
  id: enums_1.CurrencyEnum.nok,
  symbol: 'NOK',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.NOK'
}), _a[enums_1.CurrencyEnum.dkk] = new Currency({
  id: enums_1.CurrencyEnum.dkk,
  symbol: 'DKK',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.DKK'
}), _a[enums_1.CurrencyEnum.isk] = new Currency({
  id: enums_1.CurrencyEnum.isk,
  symbol: 'ISK',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.ISK'
}), _a[enums_1.CurrencyEnum.hrk] = new Currency({
  id: enums_1.CurrencyEnum.hrk,
  symbol: 'HRK',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.HRK'
}), _a[enums_1.CurrencyEnum.ron] = new Currency({
  id: enums_1.CurrencyEnum.ron,
  symbol: 'RON',
  formatString: '{sign}{value}{symbol}',
  title: 'currency.RON'
}), _a[enums_1.CurrencyEnum.twd] = new Currency({
  id: enums_1.CurrencyEnum.twd,
  symbol: '$',
  formatString: '{symbol}{sign}{value}',
  title: 'currency.TWD'
}), _a[enums_1.CurrencyEnum.sgd] = new Currency({
  id: enums_1.CurrencyEnum.sgd,
  symbol: '$',
  formatString: '{symbol}{sign}{value}',
  title: 'currency.SGD'
}), _a[enums_1.CurrencyEnum.aed] = new Currency({
  id: enums_1.CurrencyEnum.aed,
  symbol: 'AED',
  formatString: '{symbol}{sign}{value}',
  title: 'currency.AED'
}), _a[enums_1.CurrencyEnum.amd] = new Currency({
  id: enums_1.CurrencyEnum.amd,
  symbol: '֏',
  formatString: '{symbol}{sign}{value}',
  title: 'currency.AMD'
}), _a);
